export default "__VITE_ASSET__SZAsf9ZB__"